import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface LayoutProps {
  children: React.ReactNode;
  heroContent?: React.ReactNode;
  showFullHero?: boolean;
}

export default function Layout({ children, heroContent, showFullHero = false }: LayoutProps) {
  if (showFullHero && heroContent) {
    return (
      <>
        {heroContent}
        <Navbar />
        <main>{children}</main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}